const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const SensorPeripheral = require('../common/sensor-peripheral');
const { default: bleUtils } = require('../../util/ble');
const { BLE_CONFIG } = require('../../util/bleCharac');


/**
 * 无线红外人体传感器
 * 
 * @readonly
 */
const DIVECE_OPT = {
    type: 'sensor'
};

// const BLE_CONFIG = {
//     prefix: 'LM',
//     SERVICE_UUID: 0x01FF,
//     pirStatus: 0X0380,
// }
/**
 * Manage communication with a Arduino esp32 peripheral over a Scratch Link client socket.
 */
class YMPIR extends SensorPeripheral {
    /**
     * Construct a Arduino communication object.
     * @param {Runtime} runtime - the Scratch runtime
     * @param {string} deviceId - the id of the extension
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, deviceId, originalDeviceId) {
        super(runtime, deviceId, originalDeviceId, null, BLE_CONFIG, DIVECE_OPT);
    }
}

class ScratchYMPIRDevice {

    /**
     * @return {string} - the ID of this deivce.
     */
    get DEVICE_ID() {
        return 'yiIrmotion';
    }

    /**
     * Construct a set of Arduino blocks.
     * @param {Runtime} runtime - the Scratch runtime.
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, originalDeviceId) {
        /**
         * The Scratch runtime.
         * @type {Runtime}
         */
        this.runtime = runtime;

        
        this._peripheral = new YMPIR(this.runtime, this.DEVICE_ID, originalDeviceId);
        this.bleUtils = new bleUtils();
    }

    getInfo() {
        return [{
            id: 'yiIrmotion',
            name: formatMessage({
                id: 'YMPIR.categoryName',
                default: 'YM PIR',
                description: 'Label for the YM PIR extension category'
            }),
            color1: "#E91E63",
            color2: "#D51A5C",
            color3: "#C21655",
            blocks: [
                {
                    opcode: 'connect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMPIR.ble.connect',
                        default: 'connect to YM-PIR-[DEVICE_NAME]',
                        description: 'Connect to YM-PIR'
                    }),
                    arguments: {
                        DEVICE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        }
                    }
                },
                {
                    opcode: 'disConnect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMPIR.ble.disconnect',
                        default: 'disconnect from YM-PIR',
                        description: 'Disconnect from YM-PIR'
                    })
                },
                {
                    opcode: 'getStatus',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'YMPIR.getStatus',
                        default: 'get status',
                        description: 'Detect current status'
                    }),
                },
            ],
            menus: {}
        }];
    }

    async connect(args) {
        const deviceName = 'YM-PIR-' + (args.DEVICE_NAME?.trim() || "");
        console.log("this.bleUtils.device", this.bleUtils.device);
        const connected = await this.isConnected();
        if (connected) {
            console.log('Already connected to device');
            return;
        }
        console.log(`Connecting to YM-PIR device: ${deviceName}`);
        try {
            await this.bleUtils.connect(deviceName, BLE_CONFIG.SERVICE_UUID);
            console.log(`Connected to device: ${deviceName}`);

        } catch (error) {
            console.error(`Failed to connect to ${deviceName}:`, error);
        }
    }

    async isConnected() {
        console.log('Checking if device is connected');
        return this.bleUtils.device !== null && this.bleUtils.device.gatt.connected;
    }

    async disConnect() {
        console.log('Disconnecting from YM-PIR device');
        if (this.bleUtils.device) {
            try {
                await this.bleUtils.disConnect(this.bleUtils.device);
                console.log('Disconnected from device');
            } catch (error) {
                console.error('Failed to disconnect:', error);
            }
        }
    }

    async getStatus() {
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.pirStatus);
                const dataView = await this.bleUtils.readCharacteristic(characteristic);
                const status = dataView.getUint8(0);
                console.log('Status:', status);
                return status === 1; // Return true if status is 1, otherwise false
            } catch (error) {
                console.error('Failed to get status:', error);
                return false; // Return false in case of an error
            }
        }
    }

}

module.exports = ScratchYMPIRDevice;